import List from '@mui/material/List';
import React, { ReactElement } from 'react';

import * as buyingBehalfStyles from './BuyingBehalf.styles';
import FieldsetWrapper from '../FieldsetWrapper';
import FormikError from '../FormikError';
import { AccountField } from '../../utils/forms';
import { RadioButton } from '../BooleanButton/BooleanButton';

export interface BuyingBehalfProps {
  selectedValue?: string;
  onChange: (v: string) => void;
  isError: boolean;
}

export default function BuyingBehalf({ selectedValue, onChange, isError }: BuyingBehalfProps): ReactElement {
  const handleSelect = (value: string) => () => onChange(value);

  const { classes: wrapperClasses } = buyingBehalfStyles.useWrapperStyles();

  const items = ['business', 'myself'].map((value: string) => (
    <RadioButton
      key={`buying-behalf-${value}`}
      title={value === 'business' ? 'For a business' : 'For myself'}
      selected={value === selectedValue}
      onClick={handleSelect(value)}
    />
  ));

  return (
    <FieldsetWrapper
      id="buying-behalf"
      key="buying-behalf"
      title="Are you ordering for a business or yourself?"
      smallGutter
      error={isError}
    >
      <List classes={wrapperClasses} disablePadding>
        {items}
      </List>
      <FormikError errorName={AccountField.BUYING_BEHALF} />
    </FieldsetWrapper>
  );
}
